<template>
    <div>
        <div id="smallSideBar" class="sidebar sidebar-small newtheme-sidebar">
            <div class="sidebar-cross">
                <span class="sidebar-cross-icon cross_btn" @click="toggleHandler">x</span>
            </div>
            <div class="menu-sticky">
                <ul class="nav_lis">
                    <!-- Dashboard Menu -->
                    <li @mouseover="hoveredMenu = 'dashboard'" @mouseleave="hoveredMenu = ''" @click="toggleHandler">
                        <router-link to="/tutor/dashboard">
                            <img :src="isActive('dashboard') || hoveredMenu === 'dashboard'
                                ? require('@/assets/new-theme-images/dashboard-active-icon.png')
                                : require('@/assets/new-theme-images/dashboard.png')" alt="Dashboard Icon" />
                            <span class="sidebar-links">Overview</span>
                        </router-link>
                    </li>

                    <!-- Courses Menu -->
                    <li @mouseover="hoveredMenu = 'courses'" @mouseleave="hoveredMenu = ''" @click="toggleHandler">
                        <router-link to="/tutor/courses">
                            <img :src="isActive('courses') || hoveredMenu === 'courses'
                                ? require('@/assets/new-theme-images/courses-active-icon.png')
                                : require('@/assets/new-theme-images/course.png')" alt="Courses Icon" />
                            <span class="sidebar-links">Courses</span>
                        </router-link>
                    </li>

                    <!-- Availability Menu -->
                    <li @mouseover="hoveredMenu = 'availability'" @mouseleave="hoveredMenu = ''" @click="toggleHandler">
                        <router-link to="/tutor/one-to-one-session">
                            <img :src="isActive('one-to-one-session') || hoveredMenu === 'availability'
                                ? require('@/assets/new-theme-images/availability-active.png')
                                : require('@/assets/new-theme-images/activity.png')" alt="Availability Icon" />
                            <span class="sidebar-links">Availability</span>
                        </router-link>
                    </li>

                    <!-- Appointments Menu -->
                    <li @mouseover="hoveredMenu = 'appointments'" @mouseleave="hoveredMenu = ''" @click="toggleHandler">
                        <router-link to="/tutor/booked-appointments">
                            <img :src="isActive('booked-appointments') || hoveredMenu === 'appointments'
                                ? require('@/assets/new-theme-images/appointments-active.png')
                                : require('@/assets/new-theme-images/appointments.png')" alt="Appointments Icon" />
                            <span class="sidebar-links">Appointments</span>
                        </router-link>
                    </li>

                    <!-- Messages Menu -->
                    <li @click="toggleHandler">
                        <router-link to="/tutor/chat">
                            <i class="fa fa-comments" aria-hidden="true"></i>
                            <span class="sidebar-links">Messages</span>
                        </router-link>
                    </li>

                    <!-- Get Verified Menu (Conditional) -->
                    <li v-if="!user_verified" @click="toggleHandler">
                        <router-link to="/tutor/get/verified">
                            <i class="fa fa-comments" aria-hidden="true"></i>
                            <span class="sidebar-links">Get verified</span>
                        </router-link>
                    </li>

                    <!-- Logs Submenu -->
                    <li @mouseover="hoveredMenu = 'log'" @mouseleave="hoveredMenu = ''" @click="toggleHandler"
                        :class="{ submenu_open: activeMenu === 'log' }">
                        <a @click="toggleSubMenu('log')" href="javascript:void(0)">
                            <img :src="isActive('log') || hoveredMenu === 'log'
                                ? require('@/assets/new-theme-images/availability-active.png')
                                : require('@/assets/new-theme-images/activity.png')" alt="Logs Icon" />
                            <span class="sidebar-links">Logs</span>
                        </a>
                        <div v-if="activeMenu === 'log'" class="submenu-route">
                            <router-link to="/tutor/log/session">Session Logs</router-link>
                            <router-link to="/tutor/log/activity">Activity Logs</router-link>
                        </div>
                    </li>

                    <!-- Billing Submenu -->
                    <li @mouseover="hoveredMenu = 'billing'" @mouseleave="hoveredMenu = ''" @click="toggleHandler"
                        :class="{ submenu_open: activeMenu === 'billing' }">
                        <a @click="toggleSubMenu('billing')" href="javascript:void(0)">
                            <img :src="isActive('billing') || hoveredMenu === 'billing'
                                ? require('@/assets/new-theme-images/billing-active.png')
                                : require('@/assets/new-theme-images/billings.png')" alt="Logs Icon" />
                            <span class="sidebar-links">Billing</span>
                        </a>
                        <div v-if="activeMenu === 'billing'" class="submenu-route">
                            <router-link to="/tutor/billing/deposit">Make a Deposit</router-link>
                            <router-link to="/tutor/billing/overview">Earning Overview</router-link>
                            <router-link to="/tutor/billing/transaction">Transaction History</router-link>
                            <router-link to="/tutor/billing/requests">Requests</router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { useUserStore } from "@/store/store";

export default {
    name: "SidebarComponent",
    props: {
        toggleHandler: { type: Function },
    },
    data() {
        const userStore = useUserStore();
        return {
            userDetail: userStore.currentUser,
            user_verified: userStore.isUserVerified,
            activeMenu: "",
            hoveredMenu: "", // Tracks the currently hovered menu item
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.setActiveMenu();
            }
        },
    },
    mounted() {
        this.setActiveMenu();
    },
    methods: {
        setActiveMenu() {
            const routeName = this.$route.name;
            this.activeMenu = routeName || "";
        },
        isActive(menu) {
            return this.$route.path.includes(menu);
        },
        toggleSubMenu(menu) {
            this.activeMenu = this.activeMenu === menu ? "" : menu;
        },
    },
};
</script>

<style lang="scss" scoped>
.submenu-route {
    background: #7a67c7;
    border-radius: 4px 0px 0px 42px;
    position: absolute;
    width: 100%;
    top: 33px;
    left: 4px;
    padding: 23px 15px;
    z-index: 500;
}

.submenu-route:hover {
    background: #7a67c7;
}

.submenu-route::before {
    content: "";
    width: 10px;
    height: 10px;
    background: #7a67c7;
}

.home_menus {
    display: none;
}

@media (max-width: 1231px) {
    .home_menus {
        display: block;
    }
}

li.accordion.has-submenu .submenu-route {
    display: none;
}

#smallSideBar.newtheme-sidebar .nav_lis li.accordion.has-submenu.submenu_open {
    height: 192px;
}

#smallSideBar.newtheme-sidebar .nav_lis li.accordion.has-submenu.submenu_open.logs {
    height: 152px;
}

#smallSideBar.newtheme-sidebar .nav_lis li.accordion.has-submenu.submenu_open.home_menus {
    height: 195px;
}

li.accordion.has-submenu.submenu_open .submenu-route {
    display: block;
}

span.sidebar-links {
    line-height: 0px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

ul li router-link {
    display: flex;
    align-items: center;
    justify-content: center;
}

ul li img {
    height: 24px;
    width: 24px;
    margin-left: 12px;
}

ul li img:hover {
    background: transparent;
}

ul li i {
    font-size: 20px;
    margin-right: -14px;
}

ul li i:hover {
    background: transparent;
}
</style>
